"use client";

import { useEffect } from "react";
import { AutoGoogleSignIn } from "./GoogleSignIn";
import type { AppConfig } from "../config/get-config";
import api from "../services/api";

export default function HomeClientInit({
  appConfig,
}: {
  appConfig: AppConfig;
}) {
  useEffect(() => {
    api.defaults.baseURL = appConfig.apiUrl;
  }, [appConfig]);

  return (
    <>
      <AutoGoogleSignIn clientId={appConfig.googleWebClientId} />
    </>
  );
}
